import { render, staticRenderFns } from "./institute.vue?vue&type=template&id=ffe679bc&scoped=true&"
import script from "./institute.vue?vue&type=script&lang=js&"
export * from "./institute.vue?vue&type=script&lang=js&"
import style0 from "./institute.vue?vue&type=style&index=0&id=ffe679bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe679bc",
  null
  
)

export default component.exports